import { render, staticRenderFns } from "./boses.vue?vue&type=template&id=2200d77b&"
import script from "./boses.vue?vue&type=script&lang=js&"
export * from "./boses.vue?vue&type=script&lang=js&"
import style0 from "./boses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports